export const strict = false;

export const state = () => ({
  formStatus: {
    sending: false,
    complete: false,
    errors: {},
  }
})

export const actions = {
  sendForm(context, formdata) {
    var formStatus = [];
    formStatus.type = 'sending';
    formStatus.todo = true;
    context.commit('updateFormStatus', formStatus);
    var alertObj = {};
    
    this.$axios.post(process.env.API_URL + process.env.API_PREFIX + '/mail', formdata)
    .then(response => {
      formStatus.type = 'sending';
      formStatus.todo = false;
      context.commit('updateFormStatus', formStatus);

      formStatus.type = 'complete';
      formStatus.todo = true;
      context.commit('updateFormStatus', formStatus);
      if (typeof formdata.get === 'function') {
        var return_url = formdata.get('return_url');
        if (return_url) {
          var goto = window.location.protocol + '//' + window.location.host + window.location.pathname + return_url;
          return window.location = goto;
        }
      } 
      if (formdata.return_url) {
       var goto = window.location.protocol + '//' + window.location.host + window.location.pathname + formdata.return_url;
       return window.location = goto;
     }
     return true
   }).catch((error) => {
    console.log(error);
    alertObj.type = 'error';
    alertObj.message = 'Er is iets mis gegaan. Probeer het opnieuw of stuur een mailtje naar info@meidenvanholland.nl';
    context.commit('alertStore/setAlert', alertObj, { root: true });  

    formStatus.type = 'sending';
    formStatus.todo = false;
    context.commit('updateFormStatus', formStatus);

    formStatus.type = 'send';
    formStatus.text = true;
    context.commit('updateFormStatus', formStatus);

    this.$sentry.captureException(error);
  });
 },
 newsletter(context, formdata) {
  var formStatus = [];
  var todo = 'add'
  if (formdata.subscribe === 0) {
    todo = 'remove'
  }
  this.$axios.post(process.env.API_URL + process.env.API_PREFIX + '/segment/' + todo + '-email/' + formdata.segment, formdata)
  .then(response => {
    formStatus.type = 'sending';
    formStatus.todo = false;
    context.commit('updateFormStatus', formStatus);
    
    formStatus.type = 'complete';
    formStatus.todo = true;
    context.commit('updateFormStatus', formStatus);
    if(response.data && response.data.message && response.data.message === 'exist') {
      var alertObj = [];
      alertObj.type = 'info';
      alertObj.message = 'Je bent al lid van onze nieuwsbrief.';
      context.commit('alertStore/setAlert', alertObj, { root: true });  
      return;
    }
    if (formdata.subscribe === 1) {
      var goto = window.location.href + '/bedankt';
    } else {
      var goto = window.location.href + '/uitgeschreven';
    }
    window.location = goto;

  }).catch((error) => {
    console.log(error);
    var alertObj = [];
    alertObj.type = 'error';
    alertObj.message = 'Er is iets mis gegaan. Probeer het opnieuw of stuur een mailtje naar info@meidenvanholland.nl';
    context.commit('alertStore/setAlert', alertObj, { root: true });  

    formStatus.type = 'sending';
    formStatus.todo = false;
    context.commit('updateFormStatus', formStatus);

    formStatus.type = 'send';
    formStatus.text = true;
    context.commit('updateFormStatus', formStatus);

    this.$sentry.captureException(error);
  });
},
newsletterAuth(context, formdata) {
  var formStatus = [];
  this.$axios.post(process.env.API_URL + process.env.API_PREFIX + '/segment/add-email/' + formdata.segment, formdata)
  .then(response => {
    formStatus.type = 'sending';
    formStatus.todo = false;
    context.commit('updateFormStatus', formStatus);

    formStatus.type = 'complete';
    formStatus.todo = true;
    context.commit('updateFormStatus', formStatus);
    if (formdata.subscribe === 1) {
      var alertObj = {
        type: 'succes',
        message: 'Je bent nu ingeschreven voor onze nieuwsbrief. Welkom!',
      };
      context.commit('alertStore/setAlert', alertObj, { root: true });
    } else {
      var alertObj = {
        type: 'info',
        message: 'Je bent uitgeschreven voor onze nieuwsbrief. Je zal deze niet meer ontvangen.',
      };
      context.commit('alertStore/setAlert', alertObj, { root: true });
    }

  }).catch((error) => {
    console.log(error);
    var alertObj = [];
    alertObj.type = 'error';
    alertObj.message = 'Er is iets mis gegaan. Probeer het opnieuw of stuur een mailtje naar info@secretcircle.com';
    context.commit('alertStore/setAlert', alertObj, { root: true });  

    formStatus.type = 'sending';
    formStatus.todo = false;
    context.commit('updateFormStatus', formStatus);

    formStatus.type = 'send';
    formStatus.text = true;
    context.commit('updateFormStatus', formStatus);

    this.$sentry.captureException(error);
  });
},
}

export const mutations = {
  updateFormStatus(state, data) {
    state.formStatus[data.type] = data.todo;
  },
  updateErrors(state, data) {
    state.formStatus.errors[data.type] = data.text;
  },
  resetErrors(state) {
    state.formStatus.errors = {};
  },
  resetFormStatus(state) {
    state.formStatus = {
      sending: false,
      complete: false,
      errors: {},
    };
  }
}